import { Theme, Typography, makeStyles } from '@material-ui/core'
import { AutoCompleteInputMultiSelect } from 'bpm/pages/ProductsPage/AddProductDialog/AutoCompleteInput'
import React, { FC, useCallback } from 'react'
import { NoteTypeReasonOption } from '../ListingNotes.types'

const useStyles = makeStyles((theme: Theme) => ({
    noteTypeFilter: {
        flex: 8,
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
        '& .MuiAutocomplete-root, .MuiInputBase-root ': {
            backgroundColor: theme.palette.common.white,
        },
    },
}))

export type NoteTypeFilterProps = {
    disabled?: boolean
    noteTypes: NoteTypeReasonOption[]
    setNoteTypes: (userValues: string[]) => void
    selectedNoteTypes: NoteTypeReasonOption[]
}

const NoteTypeFilter: FC<NoteTypeFilterProps> = ({
    disabled,
    noteTypes,
    setNoteTypes,
    selectedNoteTypes,
}) => {
    const classes = useStyles()

    const noop = useCallback(() => {}, [])

    const setSelectedNoteTypes = useCallback(
        (_, value) => {
            setNoteTypes(value)
        },
        [setNoteTypes]
    )

    return (
        <Typography
            component="div"
            className={classes.noteTypeFilter}
            data-testid="notesReasonFilter"
        >
            <AutoCompleteInputMultiSelect
                disabled={disabled}
                name="notesReasonFilter"
                placeholder="Choose reason/s"
                noLabel
                items={noteTypes}
                valid={true}
                groupBy={(option) => option.noteType}
                getOptionLabel={(option) => option.reason}
                handleChange={setSelectedNoteTypes}
                selectedValues={selectedNoteTypes}
                handleInputChange={noop}
                getOptionSelected={(option, value) =>
                    option.reason === value.reason &&
                    option.noteType === value.noteType
                }
            />
        </Typography>
    )
}
export default NoteTypeFilter
